<tt-page>
    <tt-page-heading></tt-page-heading>
    <tt-project-progress-log [params]="params"></tt-project-progress-log>
</tt-page>
